const getRoot = state => state.application;
const getInited = state => getRoot(state).inited;
const getReady = state => getRoot(state).ready;
const getConfig = state => getRoot(state).config;
const getBackend = state => getConfig(state).backend;
const getPort = state => getConfig(state).port;

export {
  getRoot,
  getInited,
  getReady,
  getConfig,
  getBackend,
  getPort,
};
